import Invoice4Container from "../../../../components/applications/eCommerce/invoices/invoice4";

const Invoice4 = () => {
  return <Invoice4Container />;
};

export default Invoice4;
